<template lang="pug">
SspLayout(area="core")
  .row
    .col-md-12
      SspSaveForm(@onSubmit="save" :saveDisabled="!isValid" :saving="saving")
        .form-group
          label.col-sm-4.control-label Index
          .col-sm-8
            input.index-input.form-control(type="number" v-model="index" :disabled="codeStatusId" placeholder="Index Number")
        .form-group
          label.col-sm-4.control-label Description
          .col-sm-8
            input.index-input.form-control(type="text" v-model="description" placeholder="Description")
        .form-group
          label.col-sm-4.control-label Code Can Be Validated
          .col-sm-8
            input(type="checkbox" v-model="validatable")
        .form-group
          label.col-sm-4.control-label Code Can Be Included In Hierarchy
          .col-sm-8
            input(type="checkbox" v-model="packable")
        .form-group
          label.col-sm-4.control-label Status Can Be Unset
          .col-sm-8
            input(type="checkbox" v-model="unsettable")
</template>

<script>
import miniToastr from 'mini-toastr'
import Core from '@/service/apis/Core'

export default {
  data: () => ({
    saving: false,
    index: null,
    description: null,
    validatable: false,
    packable: false,
    unsettable: false,
  }),
  created() {
    if (this.codeStatusId) {
      Core.getCodeStatus(this.codeStatusId)
        .then((resp) => {
          this.index = resp.data.codeStatusField.id
          this.description = resp.data.codeStatusField.description
          this.validatable = resp.data.codeStatusField.validatable
          this.packable = resp.data.codeStatusField.packable
          this.unsettable = resp.data.codeStatusField.unsettable
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    }
  },
  methods: {
    save() {
      this.saving = true
      const req = {
        codeStatusField: {
          description: this.description,
          validatable: this.validatable,
          packable: this.packable,
          unsettable: this.unsettable,
          id: this.index
        }
      }

      if (this.codeStatusId) {
        req.codeStatusField = [req.codeStatusField]
      }

      const call = this.codeStatusId ? Core.updateCodeStatus(req) : Core.createCodeStatus(req)
      const action = this.codeStatusId ? 'updated' : 'created'
      call
        .then(() => {
          miniToastr.success(`Codestatus was successfully ${action}`)
          this.$router.push({ name: 'codeStatuses' })
        })
        .catch((e) => {
          this.$emit('error', e)
        })
        .then(() => {
          this.saving = false
        })
    }
  },
  computed: {
    isValid() {
      return this.index && this.description
    },
    codeStatusId() {
      return parseInt(this.$route.params.id, 10)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/configuration/codestatus/EditCodeStatuses.vue